import { Grapheme, Morpheme, Word } from '@/common/types/scopeAndSequence';
import { SoundOptions } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import SingleCharacterText from '@/game/prefabs/StudentGame/SingleCharacterText';
import StudentGameCard from '@/game/prefabs/StudentGame/StudentGameCard';

export const MINIGAME_CARD_SOUND_OPTIONS: SoundOptions = {
  randomizeVolume: true,
  volumeMin: 0.8,
  volumeMax: 1.15,
  randomizePitch: true,
  pitchMin: 0.99,
  pitchMax: 1.01,
};

export interface CardFeedback {
  card: StudentGameCard;
  isCorrect: boolean;
  grapheme?: Grapheme;
}

export interface KeyboardFeedback {
  letters: SingleCharacterText[];
  isCorrect: boolean;
  grapheme?: Grapheme;
  morpheme?: Morpheme;
  word?: Word;
}

export interface FullFeedbackOptions {
  correctAnswer: boolean;
  partiallyCorrectAnswer?: boolean;
  disableRiffle?: boolean;
  forceIndividualFeedback?: boolean;
  forceReadout?: boolean;
  feedbackCompleteCallback?: (
    feedback: CardFeedback[] | KeyboardFeedback[],
  ) => Promise<void>;
}

export const MINIGAME_CORRECT_COLOUR: number = 0x1ebc73;
export const MINIGAME_INCORRECT_COLOUR: number = 0xe64539;
export const MINIGAME_NEUTRAL_COLOUR: number = 0xff9721;
export const MINIGAME_PURPLE_COLOUR: number = 0x693cbd;
